import {
  DeleteReajusteRequest,
  DeleteReajusteResponse,
} from "./../daos/delete/delete_reajuste";
import {
  DeleteIndiceReajusteRequest,
  DeleteIndiceReajusteResponse,
} from "./../daos/delete/delete_indice_reajuste";
import { AxiosError } from "axios";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import {
  DeleteContaReceberRequest,
  DeleteContaReceberResponse,
} from "../daos/delete/delete_conta_receber";
import { IFinanceiroService } from "./financeiro_service";
import {
  GetAllContasReceberListaRequest,
  GetAllContasReceberListaResponse,
} from "../daos/read/get_all_contas_receber_lista";
import {
  RecebimentoContaRequest,
  RecebimentoContaResponse,
} from "../daos/update/recebimento_conta_receber";
import {
  ContasReceberCopiaRequest,
  ContasReceberCopiaResponse,
} from "../daos/create/contas_receber_copia";
import {
  GetContaReceberByIdRequest,
  GetContaReceberByIdResponse,
} from "../daos/read/get_conta_receber_by_id";
import {
  CreateContaReceberRequest,
  CreateContaReceberResponse,
} from "../daos/create/create_conta_receber";
import {
  UpdateContaReceberRequest,
  UpdateContaReceberResponse,
} from "../daos/update/update_conta_receber";
import {
  CancelarRecebimentoRequest,
  CancelarRecebimentoResponse,
} from "../daos/update/cancelar_recebimento";
import {
  CreateContaReceberParcialRequest,
  CreateContaReceberParcialResponse,
} from "../daos/create/contas_receber_parcial";
import {
  DeleteContaReceberParcialRequest,
  DeleteContaReceberParcialResponse,
} from "../daos/delete/delete_contas_receber_parcial";
import {
  GetAllContasReceberParcialRequest,
  GetAllContasReceberParcialResponse,
} from "../daos/read/get_all_contas_receber_parcial";
import {
  GetAllBancoPagamentoRequest,
  GetAllBancoPagamentoResponse,
} from "../daos/read/get_all_banco_pagamento";
import {
  GetBancoPagamentoByIdRequest,
  GetBancoPagamentoByIdResponse,
} from "../daos/read/get_banco_pagamento_by_id";
import {
  CreateBancoPagamentoRequest,
  CreateBancoPagamentoResponse,
} from "../daos/create/create_banco_pagamento";
import {
  UpdateBancoPagamentoRequest,
  UpdateBancoPagamentoResponse,
} from "../daos/update/update_banco_pagamento";
import {
  DeleteBancoPagamentoRequest,
  DeleteBancoPagamentoResponse,
} from "../daos/delete/delete_banco_pagamento";
import {
  GetAllContasPagarListaRequest,
  GetAllContasPagarListaResponse,
} from "../daos/read/get_all_contas_pagar_lista";
import {
  GetContasPagarByIdRequest,
  GetContasPagarByIdResponse,
} from "../daos/read/get_contas_pagar_by_id";
import {
  PagamentoContasRequest,
  PagamentoContasResponse,
} from "../daos/update/pagamento_contas_pagar";
import {
  ContasPagarCopiaRequest,
  ContasPagarCopiaResponse,
} from "../daos/create/contas_pagar_copia";
import {
  DeleteContasPagarRequest,
  DeleteContasPagarResponse,
} from "../daos/delete/delete_conta_pagar";
import {
  CreateContasPagarRequest,
  CreateContasPagarResponse,
} from "../daos/create/create_conta_pagar";
import {
  UpdateContasPagarRequest,
  UpdateContasPagarResponse,
} from "../daos/update/update_conta_pagar";
import {
  CancelarPagamentoRequest,
  CancelarPagamentoResponse,
} from "../daos/update/cancelar_pagamento";
import {
  RecuperacaoContasPagarRequest,
  RecuperacaoContasPagarResponse,
} from "../daos/update/recuperacao_conta_pagar";
import {
  RecuperacaoContasReceberRequest,
  RecuperacaoContasReceberResponse,
} from "../daos/update/recuperacao_conta_receber";
import {
  CreateSaldoBancarioRequest,
  CreateSaldoBancarioResponse,
} from "../daos/create/saldo_bancario_cadastro";
import {
  GetAllSaldoBancarioListaRequest,
  GetAllSaldoBancarioListaResponse,
} from "../daos/read/get_all_saldo_bancario_lista";
import {
  GetInformacoesBancariasRequest,
  GetInformacoesBancariasResponse,
} from "../daos/read/get_informacoes_bancarias";
import {
  GetAllIndiceReajusteRequest,
  GetAllIndiceReajusteResponse,
} from "../daos/read/get_all_indice_reajuste";
import { GetDropDownResponse } from "../../../../common/data/daos/read/get_dropdown";
import {
  CreateIndiceReajusteRequest,
  CreateIndiceReajusteResponse,
} from "../daos/create/create_indice_reajuste";
import { UpdateIndiceReajusteRequest } from "../daos/update/update_indice_reajuste";
import { GetIndiceReajusteByIdRequest, GetIndiceReajusteByIdResponse } from '../daos/read/get_indice_reajuste_by_id';
import { GetAllReajusteRequest, GetAllReajusteResponse } from '../daos/read/get_all_reajuste';
import { CreateReajusteRequest, CreateReajusteResponse } from '../daos/create/create_reajuste';
import { UpdateReajusteRequest, UpdateReajusteResponse } from '../daos/update/update_reajuste';
import { GetReajusteByIdRequest, GetReajusteByIdResponse } from '../daos/read/get_reajuste_by_id';
import { GetAllPgtoContratoFinanceiroRequest, GetAllPgtoContratoFinanceiroResponse } from '../daos/read/get_all_pgto_contrato_financeiro';
import { CreatePgtoContratoFinanceiroRequest, CreatePgtoContratoFinanceiroResponse } from '../daos/create/create_pgto_contrato_financeiro';
import { UpdatePgtoContratoFinanceiroRequest, UpdatePgtoContratoFinanceiroResponse } from '../daos/update/update_pgto_contrato_financeiro';
import { GetPgtoContratoFinanceiroByIdRequest, GetPgtoContratoFinanceiroByIdResponse } from '../daos/read/get_pgto_contrato_financeiro_by_id';
import { GetAllContratoFinanceiroRequest, GetAllContratoFinanceiroResponse } from '../daos/read/get_all_contrato_financeiro';
import { GetContratoFinanceiroByIdRequest, GetContratoFinanceiroByIdResponse } from '../daos/read/get_contrato_financeiro_by_id';
import { CreateContratoFinanceiroRequest, CreateContratoFinanceiroResponse } from '../daos/create/create_contrato_financeiro';
import { UpdateContratoFinanceiroRequest, UpdateContratoFinanceiroResponse } from '../daos/update/update_contrato_financeiro';
import { DeleteContratoFinanceiroRequest, DeleteContratoFinanceiroResponse } from '../daos/delete/delete_contrato_financeiro';
import { GetAllRateioGeralRequest, GetAllRateioGeralResponse } from '../daos/read/get_all_rateio_geral';
import { GetAllRateioGeralContaPagarRequest, GetAllRateioGeralContaPagarResponse } from '../daos/read/get_all_rateio_geral_conta_pagar';
import { CreateRateioGeralRequest, CreateRateioGeralResponse } from '../daos/create/create_rateio_geral';
import { UpdateRateioGeralRequest, UpdateRateioGeralResponse } from '../daos/update/update_rateio_geral';
import { getContaPagarRateioByIdRequest, getContaPagarRateioByIdResponse } from '../daos/read/get_conta_pagar_rateio_by_Id';
import { GetContaPagarAnaliticoFiltroRequest, GetContaPagarAnaliticoFiltroResponse } from '../daos/read/get_contas_pagar_analitico_filtro';
import { SaveContasPagarAnaliticoFiltrosRequest, SaveContasPagarAnaliticoFiltrosResponse } from '../daos/create/save_contas_pagar_analitico_filtro';
import { GetContaReceberAnaliticoFiltroRequest, GetContaReceberAnaliticoFiltroResponse } from '../daos/read/get_contas_receber_analitico_filtro';
import { SaveContasReceberAnaliticoFiltrosRequest, SaveContasReceberAnaliticoFiltrosResponse } from '../daos/create/save_contas_receber_analitico_filtro';
import { GetAllLogReajusteContratoFinanceiroRequest, GetAllLogReajusteContratoFinanceiroResponse } from '../daos/read/get_all_reajuste_contrato_financeiro';
import { GetValoresContasMesRequest, GetValoresContasMesResponse } from '../daos/read/get_valores_contas_mes';
import { GetContasPagarArquivoByIdRequest } from '../daos/read/get_contas_pagar_arquivo_by_id';
import { GetDashboardFinanceiroInfosRequest, GetDashboardFinanceiroInfosResponse } from '../daos/read/get_dashboard_infos';
import { GetDashboardFinanceiroChartRequest, GetDashboardFinanceiroChartResponse } from '../daos/read/get_dashboard_chart';
import { CreateReajusteContratoIndividualRequest, CreateReajusteContratoIndividualResponse } from '../daos/create/create_reajuste_contrato_individual';
import { GetAllLogContratoFinanceiroDetalhadoRequest, GetAllLogContratoFinanceiroDetalhadoResponse } from '../daos/read/get_all_log_contrato_financeiro_detalhado';
import { GetContasReceberArquivoByIdRequest } from "../daos/read/get_contas_receber_arquivo_by_id";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { UpdateMultaJurosContratoRequest, UpdateMultaJurosContratoResponse } from "../daos/update/update_multa_juros_contrato";
import { GetMultaJurosContasReceberRequest, GetMultaJurosContasReceberResponse } from "../daos/read/get_multa_juros_contas_receber";



export class FinanceiroService implements IFinanceiroService {

  //#region Dashboard Financeiro
  async getDashboardFinanceiroInfos(request: GetDashboardFinanceiroInfosRequest): Promise<GetDashboardFinanceiroInfosResponse> {
    try {
      const result = await axiosInstance({}).get(`/financeiro/contaspagar/dashboard/infos`);
      const response = handleAxiosResponse<GetDashboardFinanceiroInfosResponse>(result);
      return { ...response }
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  async getDashboardFinanceiroChart(request: GetDashboardFinanceiroChartRequest): Promise<GetDashboardFinanceiroChartResponse> {
    try {
      const result = await axiosInstance({}).post(`/financeiro/contaspagar/dashboard-chart`, request);
      const response = handleAxiosResponse<GetDashboardFinanceiroChartResponse>(result);
      return { ...response }
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  //#endregion





  //#region  CONTAS PAGAR

  async createContaPagar(request: CreateContasPagarRequest): Promise<CreateContasPagarResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/financeiro/contaspagar/create`,
        formData,
        options,
      );
      const response = handleAxiosResponse<CreateContasPagarResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async updateContaPagar(request: UpdateContasPagarRequest): Promise<UpdateContasPagarResponse> {

    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/financeiro/contaspagar/update`,
        formData,
        options,
      );
      const response = handleAxiosResponse<UpdateContasPagarResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllContasPagarLista(
    request: GetAllContasPagarListaRequest,
  ): Promise<GetAllContasPagarListaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contaspagar/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllContasPagarListaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllContasPagarDeletadas(
    request: GetAllContasPagarListaRequest,
  ): Promise<GetAllContasPagarListaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contaspagar/deletadas/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllContasPagarListaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getContaPagarById(
    request: GetContasPagarByIdRequest,
  ): Promise<GetContasPagarByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contaspagar/${request.idContasPagar}`,
      );
      const response = handleAxiosResponse<GetContasPagarByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async contasPagamento(
    request: PagamentoContasRequest,
  ): Promise<PagamentoContasResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contaspagar/pagamento`,
        request,
      );
      const response = handleAxiosResponse<PagamentoContasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copiaContasPagar(
    request: ContasPagarCopiaRequest,
  ): Promise<ContasPagarCopiaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contaspagar/copia`,
        request,
      );
      const response = handleAxiosResponse<ContasPagarCopiaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteContasPagarById(
    request: DeleteContasPagarRequest,
  ): Promise<DeleteContasPagarResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contaspagar/delete`,
        request,
      );
      const response = handleAxiosResponse<DeleteContasPagarResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }



  async cancelarPagamento(
    request: CancelarPagamentoRequest,
  ): Promise<CancelarPagamentoResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contaspagar/cancelar/${request.idContasPagar}`,
      );
      const response = handleAxiosResponse<CancelarPagamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllLogContratoFinanceiroDetalhadoLista(request: GetAllLogContratoFinanceiroDetalhadoRequest)
    : Promise<GetAllLogContratoFinanceiroDetalhadoResponse> {
    try {
      const result = await axiosInstance({}).post(`/financeiro/contratofinanceiro/log-contrato/getall`, request);
      const response = handleAxiosResponse<GetAllLogContratoFinanceiroDetalhadoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async recuperacaoContasPagar(
    request: RecuperacaoContasPagarRequest,
  ): Promise<RecuperacaoContasPagarResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contaspagar/recuperacao`,
        request.lista,
      );
      const response =
        handleAxiosResponse<RecuperacaoContasPagarResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getContasPagarArquivoById({
    idContasPagar,
    nroArquivo,
  }: GetContasPagarArquivoByIdRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contaspagar/${idContasPagar}/arquivo/${nroArquivo}`, {
        responseType: 'blob'
      });
      const response =
        handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion






  //#region  CONTAS RECEBER

  async getAllContasReceberLista(
    request: GetAllContasReceberListaRequest,
  ): Promise<GetAllContasReceberListaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceber/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllContasReceberListaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllContasReceberDeletadas(
    request: GetAllContasReceberListaRequest,
  ): Promise<GetAllContasReceberListaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceber/deletadas/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllContasReceberListaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getContaReceberById(
    request: GetContaReceberByIdRequest,
  ): Promise<GetContaReceberByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contasreceber/${request.idContaReceber}`,
      );
      const response = handleAxiosResponse<GetContaReceberByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async contasRecebimento(
    request: RecebimentoContaRequest,
  ): Promise<RecebimentoContaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceber/recebimento`,
        request,
      );
      const response = handleAxiosResponse<RecebimentoContaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copiaContasReceber(
    request: ContasReceberCopiaRequest,
  ): Promise<ContasReceberCopiaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceber/copia`,
        request,
      );
      const response = handleAxiosResponse<ContasReceberCopiaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteContasReceberById(
    request: DeleteContaReceberRequest,
  ): Promise<DeleteContaReceberResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceber/delete`,
        request,
      );
      const response = handleAxiosResponse<DeleteContaReceberResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createContaReceber(
    request: CreateContaReceberRequest,
  ): Promise<CreateContaReceberResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceber/create`,
        formData,
        options,
      );

      const response = handleAxiosResponse<CreateContaReceberResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async updateContaReceber(
    request: UpdateContaReceberRequest,
  ): Promise<UpdateContaReceberResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceber/update`,
        formData,
        options,
      );
      const response = handleAxiosResponse<UpdateContaReceberResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async cancelarRecebimento(
    request: CancelarRecebimentoRequest,
  ): Promise<CancelarRecebimentoResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contasreceber/cancelar/${request.idContaReceber}`,
      );
      const response = handleAxiosResponse<GetContaReceberByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async recuperacaoContasReceber(
    request: RecuperacaoContasReceberRequest,
  ): Promise<RecuperacaoContasReceberResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceber/recuperacao`,
        request.lista,
      );
      const response =
        handleAxiosResponse<RecuperacaoContasReceberResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getContasReceberArquivoById({
    idContasReceber,
    nroArquivo,
  }: GetContasReceberArquivoByIdRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contasreceber/${idContasReceber}/arquivo/${nroArquivo}`, {
        responseType: 'blob'
      });
      const response =
        handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region CONTA RECEBER PARCIAL

  async createContasReceberParcial(
    request: CreateContaReceberParcialRequest,
  ): Promise<CreateContaReceberParcialResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceberparcial/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateContaReceberParcialResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteContasReceberParcial(
    request: DeleteContaReceberParcialRequest,
  ): Promise<DeleteContaReceberParcialResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contasreceberparcial/delete/${request.id}`,
      );
      const response =
        handleAxiosResponse<DeleteContaReceberParcialResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllContasReceberParcial(
    request: GetAllContasReceberParcialRequest,
  ): Promise<GetAllContasReceberParcialResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceberparcial/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllContasReceberParcialResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region BANCO PAGAMENTO

  async getAllBancoPagamentoWithFilters(
    request: GetAllBancoPagamentoRequest,
  ): Promise<GetAllBancoPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/bancopagamento/getAll`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllBancoPagamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getBancoPagamentoById(
    request: GetBancoPagamentoByIdRequest,
  ): Promise<GetBancoPagamentoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/bancopagamento/${request.idBancoPagamento}`,
      );
      const response =
        handleAxiosResponse<GetBancoPagamentoByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createBancoPagamento(
    request: CreateBancoPagamentoRequest,
  ): Promise<CreateBancoPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/bancopagamento/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateBancoPagamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateBancoPagamento(
    request: UpdateBancoPagamentoRequest,
  ): Promise<UpdateBancoPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/bancopagamento/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateBancoPagamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteBancoPagamentoById(
    request: DeleteBancoPagamentoRequest,
  ): Promise<DeleteBancoPagamentoResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/bancopagamento/delete/${request.idBancoPagamento}`,
      );
      const response =
        handleAxiosResponse<DeleteBancoPagamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createSaldoBancario(
    request: CreateSaldoBancarioRequest,
  ): Promise<CreateSaldoBancarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/saldobancario/create`,
        request,
      );
      const response = handleAxiosResponse<CreateSaldoBancarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllSaldoBancarioLista(
    request: GetAllSaldoBancarioListaRequest,
  ): Promise<GetAllSaldoBancarioListaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/saldobancario/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllSaldoBancarioListaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region INFORMAÇÕES BANCARIAS

  async getInformacoesBancariasFuncionarioById(
    request: GetInformacoesBancariasRequest,
  ): Promise<GetInformacoesBancariasResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/commons/funcionarios/infobanco/${request.id}`,
      );
      const response =
        handleAxiosResponse<GetInformacoesBancariasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getInformacoesBancariasFornecedorById(
    request: GetInformacoesBancariasRequest,
  ): Promise<GetInformacoesBancariasResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/commons/fornecedor/infobanco/${request.id}`,
      );
      const response =
        handleAxiosResponse<GetInformacoesBancariasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region INDICE REAJUSTE

  async getAllIndiceReajusteLista(
    request: GetAllIndiceReajusteRequest,
  ): Promise<GetAllIndiceReajusteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/indicereajuste/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllIndiceReajusteResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getIndiceReajusteDropDown(): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/indicereajuste/dropdown`,
      );
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createIndiceReajuste(
    request: CreateIndiceReajusteRequest,
  ): Promise<CreateIndiceReajusteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/indicereajuste/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateIndiceReajusteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateIndiceReajuste(
    request: UpdateIndiceReajusteRequest,
  ): Promise<UpdateIndiceReajusteRequest> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/indicereajuste/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateIndiceReajusteRequest>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteIndiceReajuste(
    request: DeleteIndiceReajusteRequest,
  ): Promise<DeleteIndiceReajusteResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/indicereajuste/delete/${request.idIndiceReajuste}`,
      );
      const response =
        handleAxiosResponse<DeleteIndiceReajusteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getIndiceReajusteById(
    request: GetIndiceReajusteByIdRequest,
  ): Promise<GetIndiceReajusteByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/indicereajuste/${request.idIndiceReajuste}`,
      );
      const response =
        handleAxiosResponse<GetIndiceReajusteByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region REAJUSTE

  async getAllReajusteLista(
    request: GetAllReajusteRequest,
  ): Promise<GetAllReajusteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/reajuste/getall`,
        request,
      );
      const response = handleAxiosResponse<GetAllReajusteResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createReajuste(
    request: CreateReajusteRequest,
  ): Promise<CreateReajusteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/reajuste/create`,
        request,
      );
      const response = handleAxiosResponse<CreateReajusteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateReajuste(
    request: UpdateReajusteRequest,
  ): Promise<UpdateReajusteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/reajuste/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateReajusteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteReajuste(
    request: DeleteReajusteRequest,
  ): Promise<DeleteReajusteResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/reajuste/delete/${request.idReajuste}`,
      );
      const response = handleAxiosResponse<DeleteReajusteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReajusteById(
    request: GetReajusteByIdRequest,
  ): Promise<GetReajusteByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/reajuste/${request.idReajuste}`,
      );
      const response = handleAxiosResponse<GetReajusteByIdResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region PAGAMENTO CONTRATO FINANCEIRO

  async getAllPgtoContratoFinanceiroLista(
    request: GetAllPgtoContratoFinanceiroRequest,
  ): Promise<GetAllPgtoContratoFinanceiroResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/pgtocontratofinanceiro/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllPgtoContratoFinanceiroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async createPgtoContratoFinanceiro(
    request: CreatePgtoContratoFinanceiroRequest,
  ): Promise<CreatePgtoContratoFinanceiroResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/pgtocontratofinanceiro/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreatePgtoContratoFinanceiroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async updatePgtoContratoFinanceiro(
    request: UpdatePgtoContratoFinanceiroRequest,
  ): Promise<UpdatePgtoContratoFinanceiroResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/pgtocontratofinanceiro/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdatePgtoContratoFinanceiroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async getPgtoContratoFinanceiroById(
    request: GetPgtoContratoFinanceiroByIdRequest,
  ): Promise<GetPgtoContratoFinanceiroByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/pgtocontratofinanceiro/${request.idPgtoContratoFinanceiro}`,
      );
      const response =
        handleAxiosResponse<GetPgtoContratoFinanceiroByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async deletePgtoContratoFinanceiroById(idPgto: number): Promise<void> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/pgtocontratofinanceiro/delete/${idPgto}`,
      );
      handleAxiosResponse<void>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region CONTRATO FINANCEIRO

  async getAllContratoFinanceiroListaWithFilters(
    request: GetAllContratoFinanceiroRequest,
  ): Promise<GetAllContratoFinanceiroResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contratofinanceiro/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllContratoFinanceiroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async getContratoFinanceiroById(
    request: GetContratoFinanceiroByIdRequest,
  ): Promise<GetContratoFinanceiroByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contratofinanceiro/${request.idContratoFinanceiro}`,
      );
      const response =
        handleAxiosResponse<GetContratoFinanceiroByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async createContratoFinanceiro(
    request: CreateContratoFinanceiroRequest,
  ): Promise<CreateContratoFinanceiroResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contratofinanceiro/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateContratoFinanceiroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async updateContratoFinanceiro(
    request: UpdateContratoFinanceiroRequest,
  ): Promise<UpdateContratoFinanceiroResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contratofinanceiro/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateContratoFinanceiroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteContratoFinanceiro(
    request: DeleteContratoFinanceiroRequest,
  ): Promise<DeleteContratoFinanceiroResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contratofinanceiro/delete/${request.idContrato}`,
      );
      const response =
        handleAxiosResponse<DeleteContratoFinanceiroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async getAllLogReajusteContratoFinanceiroLista(
    request: GetAllLogReajusteContratoFinanceiroRequest,
  ): Promise<GetAllLogReajusteContratoFinanceiroResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contratofinanceiro/log-reajuste/getall`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllLogReajusteContratoFinanceiroResponse>(
          result,
        );
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async createReajusteContratoIndividual(request: CreateReajusteContratoIndividualRequest)
    : Promise<CreateReajusteContratoIndividualResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contratofinanceiro/reajuste-contrato`,
        request,
      );
      const response =
        handleAxiosResponse<CreateReajusteContratoIndividualResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async updateMultaJurosContrato(
    request: UpdateMultaJurosContratoRequest
  ): Promise<UpdateMultaJurosContratoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contratofinanceiro/update-multa-juros`,
        request,
      );
      const response = handleAxiosResponse<UpdateMultaJurosContratoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMultaJurosContasReceber(
    request: GetMultaJurosContasReceberRequest
  ): Promise<GetMultaJurosContasReceberResponse> {
    try {
      const result = await axiosInstance({}).get(`/financeiro/contratofinanceiro/get-multa-juros/${request.idContaReceber}`);
      const response = handleAxiosResponse<GetMultaJurosContasReceberResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region RATEIO GERAL

  async getAllRateioGeralLista(
    request: GetAllRateioGeralRequest,
  ): Promise<GetAllRateioGeralResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/rateiogeral/getall/${request.idContasPagar}`,
      );
      const response = handleAxiosResponse<GetAllRateioGeralResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async getAllRateioGeralContasPagarLista(
    request: GetAllRateioGeralContaPagarRequest,
  ): Promise<GetAllRateioGeralContaPagarResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/rateiogeral/getall`,
        request,
      );

      const response =
        handleAxiosResponse<GetAllRateioGeralContaPagarResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async createRateioGeral(
    request: CreateRateioGeralRequest,
  ): Promise<CreateRateioGeralResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/rateiogeral/create`,
        request,
      );
      const response = handleAxiosResponse<CreateRateioGeralResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async updateRateioGeral(
    request: UpdateRateioGeralRequest,
  ): Promise<UpdateRateioGeralResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/rateiogeral/update`,
        request.list,
      );
      const response = handleAxiosResponse<UpdateRateioGeralResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async getContaPagarRateioById(
    request: getContaPagarRateioByIdRequest,
  ): Promise<getContaPagarRateioByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/rateiogeral/contapagar/${request.idContasPagar}`,
      );
      const response =
        handleAxiosResponse<getContaPagarRateioByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteRateiosGeralById(idsContasPagar: number): Promise<void> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/rateiogeral/delete/${idsContasPagar}`,
      );
      handleAxiosResponse<void>(result);
      return;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region FILTROS CONTA PAGAR ANALITICO

  async getContasPagarAnaliticoFiltros(
    request: GetContaPagarAnaliticoFiltroRequest,
  ): Promise<GetContaPagarAnaliticoFiltroResponse | null> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contaspagar-analitico/filtros`,
      );
      const response =
        handleAxiosResponse<GetContaPagarAnaliticoFiltroResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async saveContasPagarAnaliticoFiltros(
    request: SaveContasPagarAnaliticoFiltrosRequest,
  ): Promise<SaveContasPagarAnaliticoFiltrosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contaspagar-analitico/save`,
        request,
      );
      const response =
        handleAxiosResponse<SaveContasPagarAnaliticoFiltrosResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region FILTROS CONTA RECEBER ANALITICO

  async getContasReceberAnaliticoFiltros(
    request: GetContaReceberAnaliticoFiltroRequest,
  ): Promise<GetContaReceberAnaliticoFiltroResponse | null> {
    try {
      const result = await axiosInstance({}).get(
        `/financeiro/contasreceber-analitico/filtros`,
      );
      const response =
        handleAxiosResponse<GetContaReceberAnaliticoFiltroResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async saveContasReceberAnaliticoFiltros(
    request: SaveContasReceberAnaliticoFiltrosRequest,
  ): Promise<SaveContasReceberAnaliticoFiltrosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/contasreceber-analitico/save`,
        request,
      );
      const response =
        handleAxiosResponse<SaveContasReceberAnaliticoFiltrosResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  async getValoresContasMes(
    request: GetValoresContasMesRequest,
  ): Promise<GetValoresContasMesResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/financeiro/valores-contas`,
        request,
      );
      const response = handleAxiosResponse<GetValoresContasMesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }

  }
}
